import { createAsyncThunk } from '@reduxjs/toolkit';
import { getProjectFormsSummary } from '../../services/getProjectFormsSummary.service';

// Loads the /forms/summary rollup for the lazy policy's folder headers. A
// 403 means the caller has no forms access at all, resolved as "loaded, no
// groups" rather than rethrown.
export const loadFormsSummary = createAsyncThunk(
  'projectForm/loadFormsSummary',
  async ({ projectId }) => {
    try {
      const response = await getProjectFormsSummary({ projectId });
      return {
        groups: response?.groups || [],
        complete: response?.complete ?? true,
      };
    } catch (error) {
      if (error?.response?.status === 403) {
        return { groups: [], complete: true };
      }
      throw error;
    }
  },
  {
    // Same shape as loadFormsByType's condition: skip while already
    // loading/loaded, unless `force` is passed (then skip only while
    // 'loading', so a forced reload waits out one already in flight).
    condition: ({ force } = {}, { getState }) => {
      const status = getState().projectForms.formsSummary.status;

      if (force) {
        if (status === 'loading') {
          return false;
        }
        return;
      }

      if (status === 'loading' || status === 'loaded') {
        return false;
      }
    },
  }
);
